import { IAQDeviceData, IIAQSensorThreshold, ILegendDetailsVM } from "../models/IIAQDevicesState";

export const sensorConfigJSONData: ILegendDetailsVM[] = [
  {
    "Id": 1,
    "LegendName": "temprature",
    "KPI": "temprature",
    "MinValue": -20,
    "MaxValue": 50,
    "Unit": "°C"
  },
  {
    "Id": 2,
    "LegendName": "humidity",
    "KPI": "humidity",
    "MinValue": 0,
    "MaxValue": 100,
    "Unit": "%Rh"
  },
  {
    "Id": 3,
    "LegendName": "pmi_2_5",
    "KPI": "pmi_2_5",
    "MinValue": 0,
    "MaxValue": 1000,
    "Unit": "ug/m3"
  },
  {
    "Id": 4,
    "LegendName": "pmi_1",
    "KPI": "pmi_1",
    "MinValue": 0,
    "MaxValue": 1000,
    "Unit": "ug/m3"
  },
  {
    "Id": 5,
    "LegendName": "pmi10",
    "KPI": "pmi10",
    "MinValue": 0,
    "MaxValue": 1000,
    "Unit": "ug/m3"
  },
  {
    "Id": 6,
    "LegendName": "co2",
    "KPI": "co2",
    "MinValue": 400,
    "MaxValue": 5000,
    "Unit": "ppm"
  },
  {
    "Id": 7,
    "LegendName": "tvoc",
    "KPI": "tvoc",
    "MinValue": 0,
    "MaxValue": 2000,
    "Unit": "ppb"
  },
  {
    "Id": 8,
    "LegendName": "ch2o",
    "KPI": "ch2o",
    "MinValue": 0,
    "MaxValue": 5000,
    "Unit": "ppb"
  },
  {
    "Id": 9,
    "LegendName": "co",
    "KPI": "co",
    "MinValue": 0,
    "MaxValue": 20,
    "Unit": "ppm"
  }
]


export const sensorThreshold: IIAQSensorThreshold ={
  TMP_L2: 18,
  TMP_L1: 15,
  TMP_H1: 25,
  TMP_H2: 30,

  // Humidity (0 to 100)
  HUM_L2: 35,
  HUM_L1: 30,
  HUM_H1: 60,
  HUM_H2: 70,

  // PM2.5 (0 to 1000)
  PM_T1: 10,
  PM_T2: 30,

  // CO2 (400 to 5000) → IMPORTANT FIX (was near lower edge)
  CO2_T1: 500,
  CO2_T2: 1200,

  // TVOC (0 to 2000)
  VOC_T1: 100,
  VOC_T2: 400,

  // CH2O (0 to 5000)
  CH2O_T1: 20,
  CH2O_T2: 100,

  // CO (0 to 20)
  CO_T1: 5,
  CO_T2: 15,
};